import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {leadDistributionAnalyticsReducer} from './modules/LeadDistributionAnalytics'

export default (store) => ({
  path: 'lead-distribution-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const LeadDistributionAnalytics = require('./containers/LeadDistributionAnalytics').default
      let homeReducers = require('../Home/modules/home')
      /*  Add the reducer to the store on key 'counter'  */
      const filterValuesReducer = homeReducers.filterValuesReducer;
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      injectReducer(store, {key: 'leadDistributions', reducer: leadDistributionAnalyticsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})

      cb(null, LeadDistributionAnalytics)

      /* Webpack named bundle   */
    }, 'leadDistributionAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LeadDistributionAnalytics/index.js